import classNames from "classnames";
import React from "react";
import './separator-line.scss';

interface Props {
    className?: string;
    style?: React.CSSProperties;
    color?: string;
}

const SeparatorLine = ({ className, style, color = "var(--border-light)" }: Props) => {
    return (
        <div className={classNames("separator-line", className)} style={{ width: "100%", height: "1px", backgroundColor: color, ...(style ?? {}) }} />
    );
}

export default SeparatorLine;
